import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactDOM from 'react-dom';

import Root from '../../components/root';

import store from '../../store/index';

import '../css/modal.css';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  componentDidMount() {
    this.modalTarget = document.createElement('div');
    this.modalTarget.className = 'modal fade show';
    this.modalBackdrop = document.createElement('div');
    this.modalBackdrop.className = 'modal-backdrop fade show';
    this.modalTarget.addEventListener('click', this.onCloseModalClick);
    document.body.appendChild(this.modalTarget);
    document.body.appendChild(this.modalBackdrop);
    document.body.classList.add('modal-open');
    this.customRender();
  }

  componentWillUpdate() {
    this.customRender();
  }

  componentWillUnmount() {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(this.modalTarget);
      document.body.removeChild(this.modalTarget);
      document.body.removeChild(this.modalBackdrop);
      document.body.classList.remove('modal-open');
    }, 0);
  }

  onCloseModalClick(ev) {
    if (this.modalTarget === ev.target) {
      this.props.onClose();
    }
  }

  closeModalLink() {
    return (
      <button type="button" className="btn-link modal-close-link" onClick={this.props.onClose}>
        <FormattedMessage
          id="modal.close"
          defaultMessage="close"
        />
      </button>
    );
  }

  customRender() {
    ReactDOM.render(
      <Root store={store}>
        <div className={`modal-dialog ${this.props.width}`} role="document">
          <div className="modal-content rounded">
            {this.closeModalLink()}
            {this.renderHeader()}
            <div className="modal-body">
              {this.props.children}
            </div>
          </div>
        </div>
      </Root>,
      this.modalTarget,
    );
  }

  renderHeader() {
    if (this.props.defaultHeader) {
      return <div className="modal-header pbg-modal-header" />;
    }

    return false;
  }

  renderTitle() {
    if (!this.props.title) return null;

    return <h5 className="modal-title">{this.props.title}</h5>;
  }

  render() {
    return <noscript />;
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/desktop/components/modal.js